export enum STOCK_REDUCTION_CAUSE_PERMISSIONS {
  STOCK_REDUCTION_CAUSE_VIEW = 'STOCK_REDUCTIONCAUSEVIEW',
  STOCK_REDUCTION_CAUSE_WRITE = 'STOCK_REDUCTIONCAUSEWRITE',
}
